import React from 'react';
import { fetchAuthSession } from '@aws-amplify/auth';


const DeleteCapsule = async (capsuleID: number) => {
  const apiUrl = `https://lfnawfdz0a.execute-api.ap-southeast-2.amazonaws.com/capsule/delete`; 
  const payload = {
    "capsuleID": capsuleID
  }

  try {
    const { tokens } = await fetchAuthSession();
    const authToken = tokens?.accessToken?.toString();

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'x-api-key': authToken!, // Assuming token is available in fetchAuthSession
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    if (response.ok) {
      const data = await response.json();
      console.log(response);
      return data;
    } else {
      console.error('Failed to delete capsule');
      return null;
    }
  } catch (err) {
    console.error('Failed to delete capsule', err);
    return null;
  }
};

export default DeleteCapsule;
